import { SignalNames, ThemeSignalColor } from '../../theme';

export const getColorTokenName = (name: string) => {
  if (!name || name?.startsWith('#') || name?.startsWith('rgba') || name?.startsWith('hsla') || name?.startsWith('var(')) {
    return { value: name, variable: false };
  }

  if (name.startsWith('--')) {
    return { value: name, variable: true };
  }

  const [base, facet] = name.split('.');
  const isSignalName = SignalNames.includes(base as ThemeSignalColor);
  const colorBaseName = [isSignalName ? 'signal--' : '', base].join('');

  return {
    value: `--theme--color--${colorBaseName}--${facet ?? 'main'}`,
    variable: true,
  };
};